var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('WheelTyreManagerStyled', [_vm._v(" manager ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }